/**
 * Components / Templates:Promo Banner
 * ------------------------------------------------------------------------------
 * Handles the boost PLP base template promo banner template.
 *
 *
 */
function artDirectionImage(desktopImage, mobileImage, imageAlt) {
  return "\n  <picture>\n    <source data-srcset=\"".concat(mobileImage, "\" media=\"--small\">\n    <source data-srcset=\"").concat(mobileImage, "\" media=\"--medium\">\n    <source data-srcset=\"").concat(desktopImage, "\" media=\"--large\">\n    <source data-srcset=\"").concat(desktopImage, "\">\n    <img\n      class=\"lazyload blur-up\"\n      alt=\"").concat(imageAlt, "\"\n      data-src=\"").concat(mobileImage, "\"\n    >\n  </picture>\n  ");
}

export default (promoBanner => {
  const {
    desktopImage,
    mobileImage,
    imageAlt,
    textColor,
    header,
    ctaText,
    ctaUrl
  } = promoBanner;

  const buttonColor = () => {
    return textColor === '#fff' ? 'light' : 'dark';
  };

  return "\n    <div class=\"bc-sf-filter-product-item bc-promo-banner\" js-promo-banner=\"container\">\n      <div class=\"bc-promo-banner__image\">\n        ".concat(artDirectionImage(desktopImage, mobileImage, imageAlt), "\n      </div>\n      <div class=\"container\">\n        <div class=\"row no-margin-bottom\">\n          <div class=\"col xs12\">\n          <div\n            class=\"bc-promo-banner__container\"\n            style=\"color: ").concat(textColor, "\"\n          >\n            <h2>").concat(header, "</h2>\n            <a\n              class=\"\n              button\n              button--secondary\n              button--secondary-").concat(buttonColor(), "\n              \"\n              href=\"").concat(ctaUrl, "\"\n              js-hero-banner=\"link\"\n            >\n              ").concat(ctaText, "\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  ");
});